import React, { useEffect, useState } from 'react';
import { Download, X } from 'lucide-react';
import { Dialog, DialogContent, DialogTitle } from '../../../components/ui/dialog';
import { fileUrl } from '../../salesApi';
import { useT } from '../../salesI18n';
import { IllustrativeBadge } from '../../../components/IllustrativeBadge';

// Comparador antes/depois com slider + troca de cor
export const BeforeAfterDialog = ({ open, onOpenChange, photo, items = [], initialItemId }) => {
  const { t } = useT();
  const [pos, setPos] = useState(50);
  const [itemId, setItemId] = useState(initialItemId);
  useEffect(() => { if (open) { setItemId(initialItemId); setPos(50); } }, [open, initialItemId]);

  const done = items.filter((i) => i.status === 'done' && i.file_id);
  const current = done.find((i) => i.id === itemId) || done[0];
  if (!photo || !current) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sales-dark max-w-5xl p-0 overflow-hidden border-none text-white [&>button]:hidden" data-testid="before-after-dialog">
        <DialogTitle className="sr-only">{t.compare}</DialogTitle>
        <div className="flex items-center justify-between px-4 py-3 border-b border-white/10">
          <div className="flex items-center gap-2 text-sm">
            <span className="h-4 w-4 rounded-full border border-white/30" style={{ background: current.color.hex }} />
            <span className="font-semibold">{current.color.name}</span>
            <span className="text-white/50">· {t.styles[current.window_style] || ''}</span>
          </div>
          <div className="flex items-center gap-2">
            <a href={fileUrl(current.file_id)} download={`${current.color.name}.jpg`} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 h-9 px-3 rounded-lg bg-white/10 hover:bg-white/20 text-xs font-semibold" data-testid="before-after-download"><Download className="h-4 w-4" /> {t.download}</a>
            <button type="button" onClick={() => onOpenChange(false)} className="h-9 w-9 rounded-lg bg-white/10 hover:bg-white/20 flex items-center justify-center" aria-label={t.close} data-testid="before-after-close"><X className="h-4 w-4" /></button>
          </div>
        </div>

        <div className="bg-black flex justify-center">
        <div className="relative select-none" style={{ aspectRatio: `${photo.width || 4} / ${photo.height || 3}`, width: `min(100%, calc(70vh * ${(photo.width || 4) / (photo.height || 3)}))` }} data-testid="before-after-stage">
          <img src={fileUrl(current.file_id)} alt={t.after} className="absolute inset-0 w-full h-full object-contain" draggable={false} />
          <div className="absolute inset-0 overflow-hidden" style={{ width: `${pos}%` }}>
            <img src={fileUrl(photo.id)} alt={t.before} className="absolute inset-0 h-full object-contain" style={{ width: `${10000 / pos}%`, maxWidth: 'none' }} draggable={false} />
          </div>
          <div className="absolute top-0 bottom-0 w-0.5 bg-white shadow-[0_0_0_1px_rgba(0,0,0,.4)]" style={{ left: `${pos}%` }}>
            <span className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 h-10 w-10 rounded-full bg-white text-black flex items-center justify-center text-xs font-bold shadow-lg">⇆</span>
          </div>
          <span className="absolute top-3 left-3 rounded-md bg-black/60 px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wider">{t.before}</span>
          <span className="absolute top-3 right-3 rounded-md bg-primary px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wider">{t.after}</span>
          <IllustrativeBadge text={t.illustrative} className="bottom-3 right-3" testId="before-after-illustrative" />
          <input type="range" min="0" max="100" value={pos} onChange={(e) => setPos(Number(e.target.value))} className="absolute inset-0 w-full h-full opacity-0 cursor-ew-resize" aria-label={t.dragToCompare} data-testid="before-after-slider" />
        </div>
        </div>

        <div className="flex gap-2 overflow-x-auto px-4 py-3 sales-kanban-scroll" data-testid="before-after-colors">
          {done.map((i) => (
            <button key={i.id} type="button" onClick={() => setItemId(i.id)} data-testid={`before-after-color-${i.color.id}`} className={`shrink-0 inline-flex items-center gap-2 h-9 px-3 rounded-full border text-xs font-semibold transition-colors ${i.id === current.id ? 'border-primary bg-primary/20' : 'border-white/15 hover:bg-white/10'}`}>
              <span className="h-3.5 w-3.5 rounded-full border border-white/30" style={{ background: i.color.hex }} /> {i.color.name}
            </button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};
